import { useEffect } from 'react';
import { useBrandingContext } from '@/contexts';
import { BrandingImageType } from '../BrandingImage';

const MetadataInjector = () => {
  const { getBrandingLogo, getClientName, hasBranding, branding } =
    useBrandingContext();

  const title = hasBranding ? branding?.branding?.tabName : '';
  const description = hasBranding
    ? `${getClientName()} Classroom Platform`
    : '';
  const favicon = hasBranding ? getBrandingLogo(BrandingImageType.ISO) : '';

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (description) {
      let meta: HTMLMetaElement | null = document.querySelector(
        "meta[name='description']",
      );
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = description;
    }

    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = favicon!;
    document.head.appendChild(link);
  }, [favicon, title, description]);

  return null;
};

export default MetadataInjector;
